var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownSmall = function SvgArrowDownSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.093 8.331a1 1 0 0 1 1.487 1.338l-4.705 5.256a1 1 0 0 1-1.487 0L6.757 9.669a1 1 0 1 1 1.486-1.338l3.889 4.43 3.961-4.43Z"
  })));
};
export default SvgArrowDownSmall;